import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Clock } from "lucide-react";

export const TrialPill = () => {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/billing").then(({ data }) => setBilling(data)).catch(() => {});
  }, [user]);

  if (!billing || billing.billing_status !== "trialing") return null;

  const ends = billing.trial_ends_at ? new Date(billing.trial_ends_at) : null;
  const daysLeft = ends ? Math.max(0, Math.ceil((ends - Date.now()) / 86400000)) : null;
  if (daysLeft === null) return null;

  const canUpgrade = user?.role === "owner" || user?.role === "admin" || user?.global_admin;
  const expired = daysLeft <= 0;

  return (
    <div
      className={`mb-4 flex flex-wrap items-center justify-between gap-2 rounded-lg border px-4 py-2 text-sm ${
        expired ? "border-red-200 bg-red-50 text-red-800" : "border-gold/50 bg-gold/10 text-[#6b5410]"
      }`}
      data-testid="trial-pill"
    >
      <span className="flex items-center gap-2">
        <Clock className="h-4 w-4" />
        {expired
          ? "Your free trial has ended. Choose a plan to keep adding data."
          : `Free trial · ${daysLeft} day${daysLeft === 1 ? "" : "s"} left`}
      </span>
      {canUpgrade && (
        <Link to="/app/billing" className="font-semibold underline underline-offset-2 hover:opacity-80" data-testid="trial-pill-upgrade">
          {expired ? "Choose a plan" : "Upgrade"}
        </Link>
      )}
    </div>
  );
};
